import AppAdapter from 'adapters/app';

class BankAdapter extends AppAdapter {
  constructor(props) {
    super(props)
  }

	static userId = '';
	static providerId = '';
}

export default BankAdapter;